import { meetingAvailabilityActions } from './meeting-availability.actions';
import { CoreAppState } from '../core-app.state';
import {
  BaseResourceState,
  createBaseResourceReducer,
  initialResourceState,
} from '../create-base-resource-reducer';
import { MeetingAvailabilityResourceTypeMappings } from '@aa/nest/resource';

export type MeetingAvailabilityState =
  BaseResourceState<MeetingAvailabilityResourceTypeMappings>;
export const initialMeetingAvailabilityState: MeetingAvailabilityState =
  initialResourceState;

export const meetingAvailabilityReducer = createBaseResourceReducer<
  MeetingAvailabilityResourceTypeMappings,
  MeetingAvailabilityState
>(initialMeetingAvailabilityState, meetingAvailabilityActions);

export const selectMeetingAvailabilityState = (state: CoreAppState) =>
  state.meetingAvailability ?? initialMeetingAvailabilityState;
